import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ForgotPasswordService {
	private url = environment.api;

	constructor(private http: HttpClient) { }

	sendForgotRequest(data: any) {
		return this.http.post(this.url + "api/user/password/recover", data);
	}
}